import { Skeleton } from "@/components/ui/skeleton";
import { CompraExtratoDto } from "@/dtos/CompraExtratoDto"
import CompraService from "@/services/CompraService";
import { ReceiptText } from "lucide-react";
import { useEffect, useState } from "react"

export function ExtratoCreditos() {

    const [loading, setLoading] = useState<boolean>(true);
    const [extrato, setExtrato] = useState<CompraExtratoDto[]>([]);

    useEffect(() => {
        BuscarExtratos();
    }, [])

    async function BuscarExtratos() {
        try {
            const result = await CompraService.BuscaExtrato();
            setExtrato(result.Data.Lancamentos);
            setLoading(false);
        } catch (error) {

        }
    }

    return (
        <>
            {
                loading ? (
                    <div className="flex items-center">
                        <Skeleton className="h-dvh bg-primary w-screen rounded-xl" />
                    </div>) : (
                    <>
                        <div className="mx-4 my-4">
                            <h2 className="text-primary font-bold text-2xl">Extrato de Créditos</h2>
                            <p>Confira seu extrato de créditos</p>

                            <div className="grid grid-cols-4 gap-2 rounded-t-md px-4 py-2 bg-primary-foreground text-primary text-nowrap mt-2">
                                <div>
                                    <p> <ReceiptText className="inline mr-1" /> Data </p>
                                </div>
                                <div>
                                    <p>Descrição</p>
                                </div>
                                <div className="text-center">
                                    <p>Entrada</p>
                                </div>
                                <div className="text-center">
                                    <p>Saída</p>
                                </div>
                            </div>

                            {
                                extrato?.map((compra, i) => {
                                    return (
                                        <div key={i} className="grid grid-cols-4 gap-2 px-4 py-2 border-t-2 text-wrap">
                                            <div>
                                                <p> {compra.DataFormatada} </p>
                                            </div>
                                            <div>
                                                <p> {compra.Descricao} </p>
                                            </div>
                                            <div className="text-center">
                                                <p> {compra.ValorEntrada ? compra.ValorEntrada : ''} </p>
                                            </div>
                                            <div className="text-center">
                                                <p> {compra.ValorSaida ? compra.ValorSaida : ''} </p>
                                            </div>
                                        </div>

                                    )
                                })
                            }

                        </div>
                    </>
                )
            }
        </>
    )
}